import { useDispatch, useSelector } from "react-redux";
import styles from "./FilterPillButton.module.scss";
import ChevronDown from "../../assets/icons/chevron-down.svg";
import {
  AnalyticsTypeMap,
  canSelectMultipleFilters,
  FilterPillMap,
  FIXTURES_VIEW,
  LOCATION_MAP,
  ODDS_VIEW,
} from "../../constants";
import { sendAnalyticsEvent } from "../../lib/postMessage";
import { FILTERS, OPEN } from "../../constants/analytics";

const FilterPillButton = ({ name, label }) => {
  const dispatch = useDispatch();
  const { activeView } = useSelector((state) => state.view);
  const { prefetchedFilters } = useSelector((state) => state.filter);
  const filterName = name.toLowerCase();

  const filterTypeMap = new Map([
    [
      FIXTURES_VIEW,
      [
        ...prefetchedFilters.fixtures.today,
        ...prefetchedFilters.fixtures.tomorrow,
      ],
    ],
    [
      ODDS_VIEW,
      [prefetchedFilters.odds.minOdds, prefetchedFilters.odds.maxOdds].filter(
        (odds) => {
          // if the item is equal to 19 (the "max" value) then filter it out so we don't show an indicator for it
          return odds && odds !== 19;
        }
      ),
    ],
  ]);

  function getSelectionCount() {
    if (filterName === ODDS_VIEW && filterType.length > 0) {
      return 1;
    }
    return filterType.length;
  }

  const filterType =
    filterTypeMap.get(filterName) ?? prefetchedFilters[filterName];

  // Check to see if this is a filter where you can make multiple selections
  const isMultipleSelection = canSelectMultipleFilters.includes(filterName);

  // If this is a filter where you can make multiple selections and a filter selection has been
  // added to the filter array we render the filter count icon.
  const renderCount =
    isMultipleSelection && filterType.length > 0 ? (
      <div className={styles.filterPillButtonCount}>
        <span>{getSelectionCount()}</span>
      </div>
    ) : null;

  const handleFilter = (filter) => {
    window.scrollTo(0, 0);
    dispatch({ type: "SET_ACTIVE_FILTER_VIEW", payload: filter });
    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get(filter) ?? filter,
      action: OPEN,
      location: LOCATION_MAP.get(activeView) || "",
    });
  };

  return (
    <button
      className={`${styles.filterPillButton} ${
        isMultipleSelection && filterType.length > 0
          ? styles["filterPillButton--active"]
          : ""
      }`}
      aria-label={`filter-pill-${name}`}
      onClick={() => handleFilter(FilterPillMap.get(name))}
    >
      <div className={styles.filterPillButtonName}>{label || name}</div>
      {renderCount}
      <img src={ChevronDown} alt="Chevron Down" />
    </button>
  );
};

export default FilterPillButton;
